import React from "react";
import { RotateCcw } from "lucide-react";
import { StatCards, PerPerfumeTable, ArchiveList } from "./dashboard/DashboardParts";
import { WhatsAppCard } from "./dashboard/WhatsAppCard";

const periodLabel = (start) => `الفترة الحالية${start ? ` · منذ ${String(start).slice(0, 10)}` : " · منذ البداية"}`;

export function DashboardTab({ ctx }) {
  const { stats, archives, resetting, resetStats, deleteArchive, downloadArchiveCsv } = ctx;
  return (
    <div>
      <div className="flex items-center justify-between mb-8 gap-4 flex-wrap">
        <div>
          <h1 className="serif text-3xl">Dashboard</h1>
          <p className="text-[11px] uppercase tracking-widest text-[#8A857D] mt-2">{periodLabel(stats.period_start)}</p>
        </div>
        <button onClick={resetStats} disabled={resetting} data-testid="stats-reset-btn"
          className="flex items-center gap-2 border border-[#C49A6C] text-[#C49A6C] text-xs uppercase tracking-[0.18em] px-5 py-3 hover:bg-[#C49A6C] hover:text-[#0B0A08] transition-colors disabled:opacity-50">
          <RotateCcw size={15} /> {resetting ? "جارٍ الحفظ…" : "حفظ وتصفير الأرقام"}
        </button>
      </div>
      <WhatsAppCard />
      <StatCards stats={stats} />
      <PerPerfumeTable rows={stats.per_product} />
      <ArchiveList archives={archives} onCsv={downloadArchiveCsv} onDelete={deleteArchive} />
    </div>
  );
}
